export default {"src":"/_next/static/media/looking-ahead-sm.colour.0ecb6a7f.svg","height":364,"width":364,"blurWidth":0,"blurHeight":0};